import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';

import { taskHelper } from '@common/utils';
import { THEME } from './constants';

import './table_status_badge_in_progress.scss';

const { isTaskRunning, isTaskPaused } = taskHelper;

const CLASS_NAME = 'table-status-badge-in-progress';

const TableStatusBadgeInProgress = ({ task, time, lastFinished, exceededEstimation, theme }) => {
  const isPaused = isTaskPaused(task);
  const isActive = isTaskRunning(task);

  return (
    <Badge
      className={classnames(`${CLASS_NAME} badge-in_progress`, {
        [`-theme-${theme}`]: theme,
        '-active': isActive,
        '-exceed-estimation': exceededEstimation,
        '-finished': lastFinished,
        '-paused': isPaused,
      })}
    >
      <span className={`${CLASS_NAME}__time`}>{time}</span>
    </Badge>
  );
};

TableStatusBadgeInProgress.propTypes = {
  exceededEstimation: PropTypes.bool,
  lastFinished: PropTypes.bool,
  task: PropTypes.shape({}),
  theme: PropTypes.oneOf(_.values(THEME)),
  time: PropTypes.string,
};

TableStatusBadgeInProgress.defaultProps = {
  theme: THEME.DEFAULT,
};

export default TableStatusBadgeInProgress;
